import {AbstractApiRequestInterceptor} from 'core/abstract/AbstractApiRequestInterceptor';
import {APP_BUILD_VERSION, APP_VERSION} from 'core/constants';
import {isBrowserContext} from 'core/helpers';
import {ContextService, InitialContextService} from 'core/services/ContextService';
import {IRequestOptions, TJson, TRequestParameters} from 'core/types';
import {GetServerSidePropsContext} from 'next';

export class PlatformInfoRequestInterceptor extends AbstractApiRequestInterceptor {
    protected platform: string = 'Undefined';

    protected version: string = APP_VERSION;
    protected buildVersion: string = APP_BUILD_VERSION;

    protected interceptorApiUrlList = ['/auth/token'];

    private getDeviceInfo(): void {
        if (isBrowserContext()) {
            this.platform = navigator.userAgent;
            return;
        }

        // контекст в зависимости от того, где выполняется код getInitialProps/getServerSideProps
        const ctx = ContextService.ctx || InitialContextService.ctx;
        if (!ctx) {
            return;
        }

        const req = ctx.req;
        this.platform = (req as GetServerSidePropsContext['req']).headers['user-agent'] || 'Undefined';
    }

    public intercept(
        request: TRequestParameters<RequestInit, Body>,
        requestOption: IRequestOptions<TJson>,
    ): TRequestParameters<RequestInit, Body> {
        const {url} = request;
        const hasToBeIntercepted = this.interceptorApiUrlList.includes(url);

        if (!hasToBeIntercepted) {
            return request;
        }

        if ('GET' === requestOption.method) {
            return request;
        }

        this.getDeviceInfo();

        try {
            request.body = {
                ...JSON.parse((request.body || '{}') as string),
                build: this.buildVersion,
                platform: this.platform,
                version: this.version,
            };
        } catch (e) {
            return request;
        }

        return request;
    }
}
